<template>
  <div class="mcat-wrapper">
    <div class="mcat-top">
      <b-button
        class="mcat-top-btn"
        @click="$bvModal.show(`add-category`)"
        variant="link"
      >Rename Category</b-button>
      <b-button class="mcat-top-btn" variant="link">
        <b-icon-plus />Add Item
      </b-button>
    </div>
    <div v-if="currentCategory" class="cat-title">{{currentCategory.name}}</div>
    <div v-if="currentCategory" class="category-body row">
      <div class="right-body col-md-9 order-1 order-md-0">
        <template v-if="!fetchingItems">
          <div v-if="categoryItems" class="items-wrapper">
            <template v-for="(item,index) in categoryItems">
              <ItemCard :key="index" :item="item" :editable="true" />
            </template>
          </div>
          <div
            v-else
            class="no-data"
          >There are no items in this category yet. Click below to add item</div>
        </template>
        <b-spinner
          v-if="fetchingItems"
          variant="info"
          style="width: 3rem; height: 3rem; margin:0 auto;"
          label="Large Spinner"
          class="d-flex justify-content-center"
        ></b-spinner>
      </div>
      <div class="sidebar col-md-3 order-0 order-md-1">
        <b-button
          @click="addItemsToCategory"
          class="mcat-top-btn mt-0 w-100"
          variant="info"
          :disabled="selectedItems.length<1"
        >
          <b-icon-plus />Add Item
        </b-button>
        <MultipleSelect
          name="select-item"
          v-model="selectedItems"
          placeholder="Type to Search Items"
          :options="formatOptions"
          :isLoading="isLoading"
          :onsearch="getItems"
          :selectedItems="selectedItems"
          :rules="'required'"
          trackBy="name"
        >
          <template v-slot:options="slotProps">
            <div class="option-name">{{slotProps.options.option.name}}</div>
          </template>
        </MultipleSelect>
        <div class="preview-items mt-4 mb-4 pb-4">
          <template v-for="(item,index) in selectedItems">
            <div :key="'selected'+index" class="selected-options mb-2">
              <div @click="removeItem(index)" class="cancel-wrapper">X</div>

              <ItemCard :item="item" :editable="false" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BIconPlus } from "bootstrap-vue";
import { auth } from "../Firebase/firebase";
import ItemCard from "../pages/components/ItemCard";
import MultipleSelect from "./components/Inputs/MultipleSelect";
export default {
  props: {},
  components: {
    BIconPlus,
    ItemCard,
    MultipleSelect
  },
  data() {
    return {
      selectedItems: [],
      isLoading: false
    };
  },
  methods: {
    async fetchCategoryItems() {
      const response = await this.$store.dispatch(
        "Category/fetchCategoryItems",
        {
          categoryName: this.currentCategory.name,
          items: this.currentCategory.items,
          load: true
        }
      );
      return response;
    },
    async getItems(query) {
      this.isLoading = true;
      const response = await this.$store.dispatch("Item/fetchItems", {
        userId: auth.currentUser.uid,
        limit: 20,
        query
      });
      this.isLoading = false;
      return response;
    },
    removeItem(index) {
      this.selectedItems.splice(index, 1);
    },
    addItemsToCategory() {
      const items = this.selectedItems.map(item => {
        return item.id;
      });

      this.$store.dispatch("Category/addItemsToCategory", {
        categoryId: this.$route.params.id,
        items
      });
    }
  },
  computed: {
    items() {
      return this.$store.state.Item.items;
    },
    categoryItems() {
      if (this.currentCategory == null) {
        return null;
      }
      return this.$store.state.Category[this.currentCategory.name];
    },
    currentCategory() {
      return this.$store.state.Category.currentCategory;
    },
    fetchingItems() {
      return this.$store.state.Category.fetchingItems;
    },
    formatOptions() {
      const newOptions = this.items.filter(item => {
        return !this.currentCategory.items.includes(item.id);
      });
      return newOptions;
    }
  },
  watch: {
    currentCategory: {
      handler(currentCategory) {
        if (currentCategory) {
          this.fetchCategoryItems();
        }
      },
      immediate: true
    }
  },
  beforeCreate() {
    const categoryId = this.$route.params.id;
    const category = this.$store.state.Category.currentCategory;
    if (!category) {
      this.$store.dispatch("Category/fetchCategory", categoryId);
    }
  },
  beforeDestroy() {
    this.$store.commit("Category/SET_CATEGORY_ITEMS", {
      categoryName: this.currentCategory.name,
      data: []
    });
  }
};
</script>

<style scoped>
.mcat-wrapper .mcat-top {
  display: flex;
  justify-content: flex-end;
}
.mcat-wrapper .mcat-top .mcat-top-btn {
  color: #2ca8ff;
  margin: 0;
  padding: 0 10px;
}

.mcat-wrapper .mcat-top .mcat-top-btn:hover {
  color: #2ca8ff;
}

.mcat-wrapper .items-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: 10px;
}

.mcat-wrapper .cat-title {
  font-weight: bold;
  font-size: 18px;
  line-height: 20px;
  /* identical to box height, or 111% */

  color: #000000;
  margin-bottom: 25px;
}
.selected-options {
  position: relative;
  padding: 10px;
  background: #2ca8ff;
  color: white;
  border-radius: 5px;
}

.preview-items {
  border-bottom: 1px solid gray;
}

.multi-style {
  border: none;
}

.cancel-wrapper {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 16px;
  cursor: pointer;
  color: white;
  font-weight: 600;
  width: 20px;
  height: 20px;
  text-align: end;
  z-index: 3;
}
</style>